import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconSend } from '@tabler/icons-react-native';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator } from 'react-native';

const theme = createDSTheme();

export function PostCommentsSendButtonContent({
  hasCommentText,
  isPending,
}: {
  hasCommentText: boolean;
  isPending: boolean;
}) {
  const { t } = useTranslation('posts');

  if (isPending) return <ActivityIndicator color={theme.colors['surface.default']} size="small" />;
  if (!hasCommentText) {
    return <IconSend color={theme.colors['icon.secondary']} size={19} strokeWidth={ICON_STROKE_WIDTH} />;
  }

  return (
    <Row alignItems="center" gap="spacing.general.x1">
      <Text color="text.inverse.primary" fontSize={13} fontWeight="700">
        {t('comments.send')}
      </Text>
      <IconSend color={theme.colors['icon.inverse.secondary']} size={17} strokeWidth={ICON_STROKE_WIDTH} />
    </Row>
  );
}
